module.exports = __webpack_public_path__ + "static/media/light-issue-reported.e812af01.svg";